import Icon, { IconNames } from 'components/Icon';

const preventInteraction = (e: React.MouseEvent) => e.preventDefault();

export const ColorFieldHelp = ({ description }: { description: string }) => {
  const iconSize = 12;
  const iconStyle = { verticalAlign: 'middle', opacity: 0.7 };

  return (
    <span
      className="color-field-help"
      aria-label={description}
      role="img"
      tabIndex={-1}
      onMouseDown={preventInteraction}
      onClick={preventInteraction}
    >
      <Icon name={IconNames.HelpCircle} size={iconSize} style={iconStyle} />
      <span className="color-field-help-tooltip">{description}</span>
    </span>
  );
};
